
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/assignment-index/jst/AssignmentGroupWeights';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, functionType="function", escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing, self=this;

function program1(depth0,data) {
  
  
  return "readonly";
  }

  buffer += "<th scope=\"row\">";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</th>\n\n<td class=\"right-align\">\n  <div class=\"input-append\">\n    <input\n      aria-label='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_group_weights")
  },data:data},helper ? helper.call(depth0, "group_weight_for_d46c5db4", "Group weight for:", options) : helperMissing.call(depth0, "t", "group_weight_for_d46c5db4", "Group weight for:", options)))
    + " ";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "'\n      type=\"text\"\n      class=\"span1 group_weight_value\"\n      value=\""
    + escapeExpression((helper = helpers.n || (depth0 && depth0.n),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.group_weight), options) : helperMissing.call(depth0, "n", (depth0 && depth0.group_weight), options)))
    + "\"\n      name=\"";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "_group_weight\"\n      ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.canChangeWeights), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += " />\n    <span class=\"add-on\">%</span>\n  </div>\n</td>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  